<template>
    <div class="h-screen bg-gray-900 flex items-center justify-center p-4">
      <section class="max-w-md mx-auto text-center py-10 px-6 bg-white dark:bg-gray-800 rounded-lg shadow-xl">
        <div class="flex flex-col items-center">
          <svg class="w-16 h-16 text-red-500 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.625 0 2.443-1.875 1.488-3.235L13.488 4.235c-.955-1.36-2.021-1.36-2.976 0L4.542 16.765c-.955 1.36-.137 3.235 1.488 3.235z"></path>
          </svg>
  
          <h1 class="text-3xl font-bold text-gray-900 dark:text-white mb-2">
            {{ translationHandler.translate('Invalid Action', 'ucfirst') }}
          </h1>
          <p class="text-gray-600 dark:text-gray-400 mb-6">
            {{ translationHandler.translate('The action you attempted is not permitted. The Cervo Digital website does not support this operation.', 'ucfirst') }}
            
          </p>
  
          <p class="font-semibold text-void">
            {{ translationHandler.translate('To continue using the site, please close the developer tools (DevTools).', 'ucfirst') }}
          </p>
        </div>
      </section>
    </div>
</template>

<script setup>

  import { sleep } from "@/composables/sleep";
  import { showToast } from "@/composables/toast";
  import { useSessionMessageStore } from "@/stores/sessionMessage";
  import { useToast } from "primevue/usetoast";
  import { onMounted } from "vue";
  import translationHandler from "@/composables/handlers/TranslationHandler";

  const sessionMessageStore = useSessionMessageStore();
  let toast = useToast();
  onMounted(() => {
    watchForMessages();
  })

  async function watchForMessages() {
    let keepRolling = true; 
    while(keepRolling) {
        await sleep(500);
        if (sessionMessageStore.hasMessage) {
            showToast(toast, sessionMessageStore.getCurrentMessage, sessionMessageStore.getMessageType);
            sessionMessageStore.cleanMessage;
            keepRolling = false;
        }
    }
}
  </script>
  